import { c as _c } from "react/compiler-runtime";
import { BasicTooltip } from '@/comps/basic-tooltip';
import { Chip } from '@/comps/chip';
import { Separator } from '@/comps/primitives/separator';
import { Button } from '@/comps/primitives/button';
import { FilterOperator, getFilterValueDisplayText, getOperatorLabel } from '@/comps/FilterPicker/filter-operators';
import { GenericFilter } from '@/comps/FilterPicker/FilterPicker';
import { getFilterTooltip } from '@/utils/filter-tooltips';
import { cn } from '@/utils/shad';
import { Info, XCircleIcon } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/comps/primitives/tooltip';
type Props = {
  filter: GenericFilter;
  fieldLabel: string;
  operator: FilterOperator;
  valueText: string;
  onRemove: () => void;
  onClickField?: () => void;
  onClickOperator?: () => void;
  onClickValue?: () => void;
  showRemoveButton?: boolean;
  className?: string;
};
export function AppliedFilterChip(t0) {
  const $ = _c(58);
  const {
    filter,
    fieldLabel,
    operator,
    valueText,
    onRemove,
    onClickField,
    onClickOperator,
    onClickValue,
    showRemoveButton: t1,
    className
  } = t0;
  const showRemoveButton = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== filter.column) {
    t2 = getFilterTooltip(filter.column);
    $[0] = filter.column;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const tooltipText = t2;
  let t3;
  if ($[2] !== filter || $[3] !== valueText) {
    t3 = getFilterValueDisplayText(filter, valueText);
    $[2] = filter;
    $[3] = valueText;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const displayValue = t3;
  const segmentClass = _temp;
  let t4;
  if ($[5] !== className) {
    t4 = cn("flex items-center gap-1 text-[12px]", className);
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = onClickValue ?? onClickOperator ?? onClickField;
  let t6;
  if ($[7] !== onClickField) {
    t6 = cn("shrink-0 font-medium text-darkgrey", segmentClass(onClickField));
    $[7] = onClickField;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onClickField) {
    t7 = e => {
      if (!onClickField) {
        return;
      }
      e.stopPropagation();
      onClickField();
    };
    $[9] = onClickField;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = onClickField ? "button" : undefined;
  let t9;
  if ($[11] !== fieldLabel || $[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t9 = <span className={t6} onClick={t7} role={t8}>{fieldLabel}</span>;
    $[11] = fieldLabel;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== tooltipText) {
    t10 = tooltipText && <Tooltip delayDuration={300}><TooltipTrigger asChild={true} onClick={_temp2}><Info size={10} className="shrink-0 cursor-pointer text-gray-500 hover:text-white" /></TooltipTrigger><TooltipContent>{tooltipText}</TooltipContent></Tooltip>;
    $[16] = tooltipText;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Separator orientation="vertical" className="mx-1 h-base w-px shrink-0 bg-darkgrey" />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== onClickOperator) {
    t12 = cn("shrink-0 font-semibold text-darkgrey", segmentClass(onClickOperator));
    $[19] = onClickOperator;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== onClickOperator) {
    t13 = e_1 => {
      if (!onClickOperator) {
        return;
      }
      e_1.stopPropagation();
      onClickOperator();
    };
    $[21] = onClickOperator;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = onClickOperator ? "button" : undefined;
  let t15;
  if ($[23] !== operator) {
    t15 = getOperatorLabel(operator);
    $[23] = operator;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t12 || $[26] !== t13 || $[27] !== t14 || $[28] !== t15) {
    t16 = <span className={t12} onClick={t13} role={t14}>{t15}</span>;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Separator orientation="vertical" className="mx-1 h-base w-px shrink-0 bg-darkgrey" />;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== onClickValue) {
    t18 = cn("min-w-0 truncate text-muted-foreground", segmentClass(onClickValue));
    $[31] = onClickValue;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== onClickValue) {
    t19 = e_2 => {
      if (!onClickValue) {
        return;
      }
      e_2.stopPropagation();
      onClickValue();
    };
    $[33] = onClickValue;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  const t20 = onClickValue ? "button" : undefined;
  const t21 = displayValue || "\u2026";
  let t22;
  if ($[35] !== t18 || $[36] !== t19 || $[37] !== t20 || $[38] !== t21) {
    t22 = <span className={t18} onClick={t19} role={t20}>{t21}</span>;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== displayValue || $[41] !== t22) {
    t23 = <BasicTooltip text={displayValue}>{t22}</BasicTooltip>;
    $[40] = displayValue;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t10 || $[44] !== t16 || $[45] !== t23 || $[46] !== t9) {
    t24 = <div className="flex max-w-[min(360px,70vw)] items-center gap-0.5">{t9}{t10}{t11}{t16}{t17}{t23}</div>;
    $[43] = t10;
    $[44] = t16;
    $[45] = t23;
    $[46] = t9;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t24 || $[49] !== t5) {
    t25 = <Chip size="small" className="max-w-full truncate rounded-[8px] bg-background px-2" variant="secondary" onClick={t5}>{t24}</Chip>;
    $[48] = t24;
    $[49] = t5;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== onRemove || $[52] !== showRemoveButton) {
    t26 = showRemoveButton && <Button aria-label="Remove filter" className="h-3 w-3 shrink-0 text-darkgrey" variant="ghost" size="icon" onClick={e_3 => {
      e_3.stopPropagation();
      onRemove();
    }}><XCircleIcon size={13} /></Button>;
    $[51] = onRemove;
    $[52] = showRemoveButton;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t25 || $[55] !== t26 || $[56] !== t4) {
    t27 = <div className={t4}>{t25}{t26}</div>;
    $[54] = t25;
    $[55] = t26;
    $[56] = t4;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  return t27;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(clickable) {
  return cn("truncate", clickable && "cursor-pointer rounded px-0.5 hover:bg-neutral-800/80 hover:underline");
}